import {
  LayoutDashboard,
  Users,
  Building2,
  FileText,
  BarChart3,
  Settings,
  Zap,
  Handshake,
  CalendarCheck,
  Sun,
  Wallet,
  MapPin,
  Sparkles,
} from "lucide-react";

/**
 * Flat navigation config — no section labels (matches Rootly clean style).
 * Help lives in the sidebar footer, not here.
 *
 * Each item:
 *   id          – unique key
 *   label       – display text
 *   href        – route path
 *   icon        – lucide-react component
 *   badge       – optional string  "BETA" | "NEW" | any
 *   badgeColor  – "blue" | "gray"
 *   children    – sub-nav items (same shape, no deep nesting)
 */
export const NAV_CONFIG = [
  {
    id: "dashboard",
    label: "Dashboard",
    href: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    id: "my-day",
    label: "My Day",
    href: "/my-day",
    icon: Sun,
  },
  {
    id: "leads",
    label: "Leads",
    href: "/leads",
    icon: Users,
    requires: { resource: "leads", action: "read" },
  },
  {
    id: "qualification",
    label: "Qualified Queue",
    href: "/qualification",
    icon: Sparkles,
    badge: "AI",
    badgeColor: "blue",
    requires: { resource: "leads", action: "read" },
  },
  {
    id: "deals",
    label: "Deals",
    href: "/deals",
    icon: Handshake,
    requires: { resource: "deals", action: "read" },
  },
  {
    id: "bookings",
    label: "Bookings",
    href: "/bookings",
    icon: CalendarCheck,
    requires: { resource: "bookings", action: "read" },
  },
  {
    id: "contacts",
    label: "Contacts",
    href: "/contacts",
    icon: Users,
    requires: { resource: "contacts", action: "read" },
  },
  {
    id: "site-visits",
    label: "Site Visits",
    href: "/site-visits",
    icon: MapPin,
    requires: { resource: "site_visits", action: "read" },
  },
  {
    id: "properties",
    label: "Properties",
    href: "/properties",
    icon: Building2,
    brokerOnly: true,
  },
  {
    id: "projects",
    label: "Projects",
    href: "/projects",
    icon: Building2,
    developerOnly: true,
    requires: { resource: "projects", action: "read" },
  },
  {
    id: "collections",
    label: "Collections",
    href: "/collections",
    icon: Wallet,
    developerOnly: true,
    requires: { resource: "bookings", action: "read" },
  },
  {
    id: "documents",
    label: "Documents",
    href: "/documents",
    icon: FileText,
    requires: { resource: "payments", action: "read" },
  },
  {
    id: "reports",
    label: "Reports",
    href: "/reports",
    icon: BarChart3,
    requires: { resource: "reports", action: "read" },
  },
  {
    id: "configurations",
    label: "Configurations",
    href: "/configurations",
    icon: Settings,
  },
];

